export const styles = {
  container:
    'tw-relative tw-grid tw-grid-cols-2 tw-gap-x-6 tw-gap-y-4 tw-p-4 tw-border-solid tw-border tw-border-neutral-200 tw-rounded-lg tw-bg-white',
  deleteButton: 'tw-absolute tw-top-2 tw-right-2',
  row: 'tw-flex tw-flex-col tw-gap-0.5',
  label: 'tw-text-xs tw-text-neutral-500',
  value: 'tw-text-sm tw-font-medium tw-text-neutral-800',
  dependencies: 'tw-col-span-2 tw-flex tw-flex-col tw-gap-0.5',
  dependenciesLabel: 'tw-text-xs tw-text-neutral-500 tw-mb-1',
  chips: 'tw-flex tw-flex-wrap tw-gap-1.5',
};
